'use strict'

import {gsap, ScrollTrigger} from '../index.js';

const init = () => {
    if (document.querySelector('body').dataset.headerAnimation) {
        gsap.registerPlugin(ScrollTrigger)

        const header = document.getElementById('main-header')
        const boxShadow = getComputedStyle(header).boxShadow
        let boxShadowBlur = 0

        if (boxShadow !== 'none') {
            boxShadowBlur = parseFloat(boxShadow.split(' ')[5])
        }

        const headerHeight = header.offsetHeight + boxShadowBlur

        const showHeaderAnimation = gsap.fromTo(header,
            {y: 0},
            {y: -headerHeight, paused: true, duration: 0.6}
        )

        let animationInitialized = false

        const onManualScroll = () => {
            if (!animationInitialized) {
                if (Math.abs(window.scrollY) > 0) {
                    ScrollTrigger.create({
                        start: 'top top',
                        end: 999999,
                        onUpdate: (self) => {
                            if (self.direction === 1) {
                                if (window.scrollY >= headerHeight) {
                                    gsap.to(header, {y: -headerHeight, duration: 0.6})
                                }
                            } else {
                                gsap.to(header, {y: 0, duration: 0.6})
                            }
                        }
                    })

                    animationInitialized = true
                    window.removeEventListener('scroll', onManualScroll)
                }
            }
        }

        setTimeout(() => {
            window.addEventListener('scroll', onManualScroll)
        }, 150)

        gsap.set(header, {yPercent: 0})
    }
}

export default {init}
